import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import MachinesTab from "../../../shared/components/tabs/machines/MachinesTab";
import * as exportOutsourceDocsActions from "../../actions/exportOutsourceDocsActions";
import StateManager from "../../../shared/utils/StateManager";

class ExportOutsourceDocsCardTabMachines extends React.Component {

  static TAB_ID = 'machines';

  static renderTabHeader() {
    return (
      <li role="presentation" className="">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_MAQUINARIA').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade" id={ExportOutsourceDocsCardTabMachines.TAB_ID}>
        <MachinesTab
          id={StateManager.EXP_DOC_TAB_MACHINES}
          companyId={this.props.companyId}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.exportOutsourceDocsActions.checkMachine}
          actionSelectAll={this.props.exportOutsourceDocsActions.checkMachines}
          selectText={I18nUtils.tr('TR_EXPORTAR')}
          selectAllText={I18nUtils.tr('TR_EXPORTAR_TODO')}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const machineIds = state.exportOutsourceDocs.machines.map(machine => machine.id);
  return {
    selectedIds: machineIds,
  }
};

const mapDispatchToProps = dispatch => ({
  exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsCardTabMachines)

ExportOutsourceDocsCardTabMachines.propTypes = {
  companyId: PropTypes.string.isRequired,
};

ExportOutsourceDocsCardTabMachines.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCardTabMachines.js